import { Component, ElementRef, ViewChild, inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AbstractDialog, AbstractDialogData, AbstractDialogResultData } from '@next/core-lib/dialog';

interface ImportDialogOutputModel {
  file: File;
  calendarYear: number;
}

@Component({
  selector: 'app-import',
  templateUrl: './import.component.html',
  standalone: false,
})
export class ImportComponent extends AbstractDialog<ImportDialogOutputModel> {
  data = inject<AbstractDialogData>(MAT_DIALOG_DATA);
  protected mdDialogRef = inject<MatDialogRef<ImportComponent, AbstractDialogResultData<ImportDialogOutputModel>>>(MatDialogRef);

  @ViewChild('file', { static: true }) inputFile: ElementRef<HTMLInputElement>;
  selectedFile: File;
  years = Array.from({ length: new Date().getFullYear() + 2 - 2020 }, (_, k) => k + 2020);
  formGroup = new FormBuilder().group({
    yearControl: [new Date().getFullYear(), [Validators.required]],
  });

  onFileSelected() {
    this.selectedFile = this.inputFile.nativeElement.files[0];
  }
}
